import * as React from 'react'
import type { NotesButtonProps } from './typings'
import { ActionButton } from '@user/features/EntityDetails/components/ActionButton'

import Typography from '@mui/material/Typography'

export function NotesButton(props: NotesButtonProps) {
  const { sx, canUpdate, onOpenNotesDrawer } = props

  return canUpdate ? (
    <ActionButton
      variant="outlined"
      sx={sx}
      onClick={onOpenNotesDrawer}
      data-test-id="add-note-button"
    >
      <Typography color="#19305A" fontFamily="Source Sans Pro Semibold">
        Add Note
      </Typography>
    </ActionButton>
  ) : null
}
